// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar.tsx';
import SinglePage from './pages/SinglePage.tsx';
import ProjectPage from './components/Projects Page/ProjectPage.tsx';
import './App.css';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { lightTheme } from './themes.js';
import Footer from './components/Footer.tsx';

function App() {
  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <div id="root">
        <Router>
          <Navbar />
          <main className="content-wrapper">
            <Routes>
              {/* All main sections share one long page */}
              <Route path="/" element={<SinglePage />} />
              <Route path="/about-us" element={<SinglePage />} />
              <Route path="/services" element={<SinglePage />} />
              <Route path="/projects" element={<SinglePage />} />
              <Route path="/news" element={<SinglePage />} />
              <Route path="/contact" element={<SinglePage />} />

              {/* Project details stay on their own pages */}
              <Route path="/projects/:projectName" element={<ProjectPage />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
